import React, { Component } from 'react';


export default class University extends Component {
  render() {
    return (
      <section className="shompi_section shompi_section_last">
        <div className="shompi_section_content">
          <div className="shompi_main_title">
            <span>My latest academic activities</span>
            <h3>Academic Activities</h3>
          </div>
          <div className="texts">
            <ul className="list">
              <li>1st Semester - 2021</li>
              <li>Database Teacher</li>
              <li>Universidad Catolica de Temuco</li>
            </ul>
            <ul className="list">
              <li>2nd Semester - 2019</li>
              <li>Chilean Olympics programming Instructor</li>
              <li>Universidad Catolica de Temuco</li>
            </ul>
            <ul className="list">
              <li>2nd Semester - 2019</li>
              <li>Course Assistant - Integration Workshop Level 3</li>
              <li>Universidad Catolica de Temuco</li>
            </ul>
            <ul className="list">
              <li>2nd Semester - 2019</li>
              <li>Course Assistant - Integration Workshop Level 2</li>
              <li>Universidad Catolica de Temuco</li>
            </ul>
            <ul className="list">
              <li>2nd Semester - 2019</li>
              <li>Course Assistant - Graphical User Interfaces</li>
              <li>Universidad Catolica de Temuco</li>
            </ul>
            <ul className="list">
              <li>1st Semester - 2019</li>
              <li>Course Assistant - Database</li>
              <li>Universidad Catolica de Temuco</li>
            </ul>
            <ul className="list">
              <li>Year 2018 to 2019</li>
              <li>President Student Center (Civil Engineering in Computer Science)</li>
              <li>Universidad Catolica de Temuco</li>
            </ul>
            <ul className="list">
              <li>2nd Semester - 2018</li>
              <li>Advanced Level Certification for Course Assistant</li>
              <li>Universidad Catolica de Temuco - 05/09/2018 al 05/10/2018</li>
            </ul>
            <ul className="list">
              <li>1st Semester - 2018</li>
              <li>Course Assistant - Database</li>
              <li>Universidad Catolica de Temuco</li>
            </ul>
            <ul className="list">
              <li>2nd Semester - 2017</li>
              <li>Basic Level Certification for Course Assistant</li>
              <li>Universidad Catolica de Temuco - 05/09/2018 al 05/10/2018</li>
            </ul>
            <ul className="list">
              <li>2nd Semester - 2017</li>
              <li>Basic Level Certification for Course Assistant</li>
              <li>Universidad Catolica de Temuco</li>
            </ul>
            <ul className="list">
              <li>2nd Semester - 2017</li>
              <li>Elementary Mathematics Instructor for primary school students</li>
              <li>Universidad Catolica de Temuco </li>
            </ul>
            <ul className="list">
              <li>2nd Semester - 2016</li>
              <li>Course Assistant - Integration Workshop Level 1</li>
              <li>Universidad Catolica de Temuco</li>
            </ul>
          </div>
        </div>
      </section>
    );
  }
}